var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.4H4.22222M4.22222 5.4H22M4.22222 5.4L4.22222 20.8C4.22222 21.3835 4.45635 21.9431 4.8731 22.3556C5.28984 22.7682 5.85507 23 6.44444 23H17.5556C18.1449 23 18.7102 22.7682 19.1269 22.3556C19.5437 21.9431 19.7778 21.3835 19.7778 20.8V5.4L4.22222 5.4ZM7.55556 5.4V3.2C7.55556 2.61652 7.78968 2.05695 8.20643 1.64436C8.62318 1.23178 9.18841 1 9.77778 1H14.2222C14.8116 1 15.3768 1.23178 15.7936 1.64436C16.2103 2.05695 16.4444 2.61652 16.4444 3.2V5.4M9.77778 10.9V17.5M14.2222 10.9V17.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconDelete);
export default __webpack_public_path__ + "static/media/button-icon-delete.38a32e3803f21ed1126e2e2b965fd8ed.svg";
export { ForwardRef as ReactComponent };